import { render } from "./RenderMathAnswer.vue?vue&type=template&id=0288faa1&ts=true"
import script from "./RenderMathAnswer.vue?vue&type=script&lang=ts"
export * from "./RenderMathAnswer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__